import React from 'react';
import { Box } from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SaveProductForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';



export type SaveProductDetailsModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveProductDetailsModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      {...props}
      title='Save Finish Information'
      subTitle='Enter Information about your finish to get started'
      headerIcon={<CustomIcon.large.FC icon='CREATOR' />}
    >
      <Box
        height='inherit'
      >
        <SaveProductForm.FC
          id={props.id}
          installationId={params.installationId ?? ''}
          handleClose={props.handleClose}

        />
      </Box>
    </BasicFormModalLayout.FC>
  );
};
